/**
 * English source-of-truth catalog for the multilingual UI toggle.
 * Phase 1 scope: Header nav, Hero, Footer, About headings, Programmes headings, Language switcher labels.
 *
 * Rules for new keys:
 *  - Use lowercase.dot.notation grouped by area (nav.about, hero.badge, footer.contact)
 *  - Keep values short — these translate cleanly. Rich prose belongs in the CMS (which stays English).
 *  - When adding a key here, the admin "Translations" tab automatically shows a row for it
 *    with a "Translate → X" button that calls Claude Sonnet to fill the other 3 languages.
 */
export const EN = {
  // Language switcher
  'lang.english': 'English',
  'lang.malay': 'Bahasa Malaysia',
  'lang.chinese': '中文',
  'lang.tamil': 'தமிழ்',
  'lang.switch_language': 'Switch language',

  // Header — nav
  'nav.about': 'About',
  'nav.projects': 'Projects',
  'nav.research': 'Research',
  'nav.branches': 'Branches',
  'nav.news_events': 'News & Events',
  'nav.gallery': 'Gallery',
  'nav.videos': 'Videos',
  'nav.careers': 'Careers',
  'nav.contact': 'Contact',
  'nav.donate_now': 'Donate Now',
  'nav.contact_us': 'Contact Us',
  'nav.room_booking': 'Room Booking',
  'nav.hq_events': 'HQ Events',
  'nav.media_coverage': 'Media Coverage',
  'nav.news_releases': 'News Releases',
  'nav.newsletter': 'News Letter',

  // Hero
  'hero.cta.programmes': 'EXPLORE OUR PROGRAMMES',
  'hero.cta.donate': '♥ DONATE NOW',
  'hero.scroll_more': 'Scroll to learn more',
  'hero.stat.years': 'Years of Impact',
  'hero.stat.lives': 'Lives Changed',
  'hero.stat.volunteers': 'Volunteers',
  'hero.stat.schools': 'Partner Schools',

  // Programmes section
  'programmes.eyebrow': 'What We Do',
  'programmes.title': 'Explore Our',
  'programmes.title_accent': 'Programmes',
  'programmes.subtitle': 'Educational, welfare and research initiatives making a difference in communities across Malaysia',
  'programmes.learn_more': 'Learn More',

  // About section common
  'about.read_more': 'Read More',
  'about.back_to_home': 'Back to Home',

  // Footer
  'footer.quick_links': 'Quick Links',
  'footer.contact_info': 'Contact Info',
  'footer.follow_us': 'Follow Us',
  'footer.our_programmes': 'Our Programmes',
  'footer.book_counselling': 'Book Counselling',
  'footer.volunteer_with_us': 'Volunteer With Us',
  'footer.donate': 'Donate',
  'footer.tax_exempted': 'Tax Exempted',
  'footer.reg_no': 'Reg. No.',
  'footer.address': 'Address',
  'footer.phone': 'Phone',
  'footer.email': 'Email',

  // Common UI
  'common.close': 'Close',
  'common.submit': 'Submit',
  'common.cancel': 'Cancel',
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.name': 'Name',
  'common.message': 'Message',

  // Project detail pages
  'project.eyebrow': 'EWRF Programme',
  'project.not_found': 'Project not found',
  'project.back_home': '← Back home',
  'project.highlights': 'Programme Highlights',
  'project.gallery': 'Programme Gallery',

  // Research Library (Research page only)
  'research.eyebrow': 'Research Library',
  'research.title': 'Published',
  'research.title_accent': 'Papers',
  'research.subtitle': 'Peer-reviewed and community-focused research papers authored or supported by EWRF Malaysia — free to read and download.',
};

/** List of all supported UI languages. Keep flag emojis simple & universal. */
export const LANGUAGES = [
  { code: 'en', label: 'English',         flag: '🇬🇧', native: 'English' },
  { code: 'ms', label: 'Bahasa Malaysia', flag: '🇲🇾', native: 'Bahasa Malaysia' },
  { code: 'zh', label: 'Mandarin',        flag: '🇨🇳', native: '中文' },
  { code: 'ta', label: 'Tamil',           flag: '🇮🇳', native: 'தமிழ்' },
];

export default EN;
